/**
 * @generated SignedSource<<7f77743486fd401623107f8543e4cfea>>
 * @relayHash bb8cea4badcfeaf6cedd6a9fc61dc70b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99b89f8fb68610aff1aabea5f0e0139006c05c1b6d79cbab227896887bcaf117

import type { ConcreteRequest } from 'relay-runtime';
export type ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation$variables = {
  archiveNote: string;
  pageId: AGG$Long;
};
export type ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation$data = {
  readonly createOrUpdateArchivePageNote: string | null | undefined;
};
export type ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation = {
  response: ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation$data;
  variables: ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "archiveNote"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "archiveNote",
        "variableName": "archiveNote"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "kind": "ScalarField",
    "name": "createOrUpdateArchivePageNote"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bb8cea4badcfeaf6cedd6a9fc61dc70b",
    "id": "99b89f8fb68610aff1aabea5f0e0139006c05c1b6d79cbab227896887bcaf117",
    "metadata": {},
    "name": "ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation",
    "operationKind": "mutation",
    "text": "mutation ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation($pageId:Long!,$archiveNote:String!){createOrUpdateArchivePageNote(pageId:$pageId,archiveNote:$archiveNote)}"
  }
};
})();

(node as any).hash = "7e1d187203a2e4e6db2cce36a3bc00a0";

export default node;
